import { render, staticRenderFns } from "./StudentLogin.vue?vue&type=template&id=4a284c6e&scoped=true"
import script from "./StudentLogin.vue?vue&type=script&lang=js"
export * from "./StudentLogin.vue?vue&type=script&lang=js"
import style0 from "./StudentLogin.vue?vue&type=style&index=0&id=4a284c6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a284c6e",
  null
  
)

export default component.exports